// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --gap: 1.5rem;
  --column-gap: 1rem;
  --control-pad: 8px;
}

.FieldsSectionBody {
  display: flex;
  flex-wrap: wrap;
  gap: var(--gap);
  column-gap: var(--column-gap);
}

.FieldsSectionHeading {
  padding-top: var(--gap);
  padding-bottom: var(--gap);
}

.FormControlContainer {
  margin: 0px;
}

.LongTextControl {
  width: 100%;
}

.ShortTextControl {
  max-width: calc(50% - var(--control-pad));
  width: 100%;
}

:is(.ShortTextControl,.LongTextControl) :is(input, select) {
  width: 100%;
}

/**
  * TODO:
  * booking engine specific styles
  * most likelly we should not have it done here
  * but this styles has to be given to BE team
  * as a css file they include in their app
*/
#cb-bookingengine .CardNumberContainer .Input > div:first-of-type {
  margin-left: 16px;
  margin-top: 16px;
}
#cb-bookingengine .CardNumberContainer .Input > #tokenexCardNumber {
  margin-left: -49px;
  padding-left: 35px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;CAMC;AACD;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B","sourcesContent":[":root {\n  --gap: 1.5rem;\n  --column-gap: 1rem;\n  --control-pad: 8px;\n}\n\n.FieldsSectionBody {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--gap);\n  column-gap: var(--column-gap);\n}\n\n.FieldsSectionHeading {\n  padding-top: var(--gap);\n  padding-bottom: var(--gap);\n}\n\n.FormControlContainer {\n  margin: 0px;\n}\n\n.LongTextControl {\n  width: 100%;\n}\n\n.ShortTextControl {\n  max-width: calc(50% - var(--control-pad));\n  width: 100%;\n}\n\n:is(.ShortTextControl,.LongTextControl) :is(input, select) {\n  width: 100%;\n}\n\n/**\n  * TODO:\n  * booking engine specific styles\n  * most likelly we should not have it done here\n  * but this styles has to be given to BE team\n  * as a css file they include in their app\n*/\n#cb-bookingengine .CardNumberContainer .Input > div:first-of-type {\n  margin-left: 16px;\n  margin-top: 16px;\n}\n#cb-bookingengine .CardNumberContainer .Input > #tokenexCardNumber {\n  margin-left: -49px;\n  padding-left: 35px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
